{
  "BAD_SEAT": "Asiento inválido.",
  "GAME_OVER": "La partida ya terminó.",
  "PLAYER_FROZEN": "Ya no participas en esta partida.",
  "STALE_DECISION": "La jugada llegó tarde: la mesa ya avanzó.",
  "WRONG_DECISION": "Ahora no se puede hacer eso.",
  "NOT_YOUR_TURN": "No es tu turno.",
  "CARD_NOT_IN_HAND": "Esa carta no está en tu mano.",
  "DUPLICATE_BUILDING": "Ya tienes ese edificio.",
  "WONDER_COMPLETE": "Tu maravilla ya está completa.",
  "INVALID_PAYMENT": "El pago no es válido.",
  "NOT_ENOUGH_COINS": "No tienes monedas suficientes.",
  "NO_RESOURCES": "No hay recursos suficientes (ni comprándolos).",
  "NO_SIDE": "Aún no has elegido lado de maravilla.",
  "NOT_A_CANDIDATE": "Esa carta no se puede construir desde el descarte.",
  "ALREADY_FROZEN": "Ese jugador ya abandonó.",
  "INVALID_COMMAND": "Acción no válida.",
  "INVALID_PAYLOAD": "Datos inválidos.",
  "RATE_LIMITED": "Vas muy rápido; espera un momento.",
  "INVALID_SESSION": "Tu sesión caducó. Vuelve a entrar.",
  "UPGRADE_REQUIRED": "Hay una versión nueva del juego. Recarga la página.",
  "NAME_IN_USE": "Ese nombre está conectado en otro navegador.",
  "INVALID_NAME": "Usa 2–20 letras, números, espacios, - o _.",
  "ROOM_NOT_FOUND": "No existe ninguna sala con ese código.",
  "ROOM_FULL": "La sala está llena (máximo 7).",
  "ALREADY_IN_ROOM": "Ya estás en otra sala ({{code}}).",
  "NOT_IN_ROOM": "No estás en ninguna sala.",
  "NOT_HOST": "Solo el anfitrión puede hacer eso.",
  "NOT_IN_LOBBY": "La partida ya empezó.",
  "NOT_PLAYING": "No hay ninguna partida en curso.",
  "NOT_ENOUGH_PLAYERS": "Se necesitan entre 3 y 7 jugadores.",
  "WONDER_TAKEN": "Otro jugador ya eligió esa maravilla.",
  "NOT_A_PLAYER": "No juegas en esta partida.",
  "TARGET_NOT_FOUND": "No se encontró a ese jugador.",
  "TARGET_CONNECTED": "Ese jugador está conectado.",
  "RETIRE_TOO_SOON": "Aún no se puede retirar (faltan {{seconds}} s).",
  "CANNOT_LEAVE_DURING_GAME": "Para salir de una partida en curso usa «Abandonar partida».",
  "INTERNAL": "Error interno del servidor.",
  "NETWORK": "No se pudo contactar con el servidor."
}
